import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import MessageAttachment from './MessageAttachment';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
  rootDesktop: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  rootMobile: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'scroll',
    backgroundColor: theme.palette.common.white,
  },
});

const MessageAttachments = ({
  classes,
  className,
  attachmentResources,
  MessageAttachmentProps,
}) => {
  const isMobile = useMobileLayout();
  return (
    <div
      className={classNames(classes.root, className, {
        [classes.rootDesktop]: !isMobile,
        [classes.rootMobile]: isMobile,
      })}
    >
      {attachmentResources.map((attachmentResource) => {
        return (
          <MessageAttachment
            key={attachmentResource.id()}
            attachmentResource={attachmentResource}
            {...MessageAttachmentProps}
          />
        );
      })}
    </div>
  );
};

MessageAttachments.defaultProps = {
  className: '',
  MessageAttachmentProps: {},
};

MessageAttachments.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  attachmentResources: PropTypes.array.isRequired,
  MessageAttachmentProps: PropTypes.object,
};

export default withStyles(styles)(MessageAttachments);
